<template>
  <header class="project-page-header">
    <slot />
    <div class="project-provenance">
      <span class="project-affiliation">{{ context }}</span>
      <span class="project-period">{{ period }}</span>
    </div>
  </header>
</template>

<script>
import { projectById } from '../../data/projects';

export default {
  name: 'ProjectPageHeader',
  props: {
    projectId: { type: String, required: true },
    context: { type: String, required: true },
  },
  computed: {
    period() {
      const value = projectById(this.projectId)?.period || '';
      const range = value.match(/^(\w+) (\d{4})\s*[-–]\s*(\w+) (\d{4})$/);
      if (range && range[2] === range[4]) return `${range[1]} to ${range[3]} ${range[4]}`;
      return value.replace(/\s+[-–]\s+/, ' to ').replace(/Present$/, 'present');
    },
  },
};
</script>
